module.exports = __webpack_public_path__ + "assets/images/logo-intro_c55381a04113fa728846c6e6d83fc3ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-intro.png
// module id = 117
// module chunks = 0